export enum MetaKey {
	MEETING_TYPE = 'meetingType',
	SUKL_LOGIN = 'suklLogin',
	SUKL_PASSWORD = 'suklPassword',
	SUKL_LOGIN_TEMPORARY = 'suklLoginTemporary',
	PROVIDER_CODE = 'providerCode',
	HEALTH_CARE_WORKER_CODE = 'healthCareWorkerCode',
	PESEL = 'pesel',
	BIRTH_PLACE = 'birthPlace',
	MOTHERS_FULLNAME = 'mothersFullname',
	TAJ = 'taj',
	EMSO = 'emso',
	JMBG = 'jmbg',
	WORKLOAD = 'workload',
	IDENTIFICATION_NUMBER = 'identificationNumber',
	CAN_CREATE_CASE_ON_PERMANENT_MEDICATION = 'canCreateCaseOnPermanentMedication',
	LAST_IDENTIFICATION_CODE = 'lastIdentificationCode',
	HEALTH_PLAN_BABY_FOR_FREE = 'HealthPlanBabyForFree',
	USE_ELECTRONIC_SIGNATURE_TIMESTAMP = 'useElectronicSignatureTimestamp',
	USE_QUALIFIED_CERTIFICATE_FOR_ELECTRONIC_SIGNATURE = 'useQualifiedCertificateForElectronicSignature',
	REQUIRE_PASSWORD_FOR_ELECTRONIC_SIGNATURE = 'requirePasswordForElectronicSignature',
	STATE = 'state',
	VZP_SUPPLEMENTARY_INSURANCE_TYPE_TERM_ITEM_ID = 'vzpSupplementaryInsuranceTypeTermItemId',
	PENDING_ACTIVATE_CALENDAR = 'pendingActivateCalendar',
	CSSZ_SSZ_CODE = 'csszSszCode',
	DIAGNOSIS = 'diagnosis',
	NCZI = 'nczi',
	INSURANCE_BATCH_INVOICE_ADVANCE_COST_TOTAL = 'insuranceBatchInvoiceAdvanceCostTotal',
	INSURANCE_BATCH_INVOICE_DUE_DAYS = 'insuranceBatchInvoiceDueDays',
	INSURANCE_BATCH_POINTS_MULTIPLIER = 'insuranceBatchPointsMultiplier',
}
